export const VACATION_HOME_ABROAD = {
  nickname: 'PRODUCTS.VACATION_HOME_ABROAD.shortname',
  isHidden: true,
  icon:'vacation-home-abroad'
};
